module.exports = __webpack_public_path__ + "img/Haefele_menu7.72c539be.png";